// extracted by mini-css-extract-plugin
export default {"wrapper":"Messages_wrapper__DecWR","wrapperMessages":"Messages_wrapperMessages__t8eiC"};